import React from "react";
import { NavLink } from "react-router-dom";
import "./SolutionsOverview.css";

import {
  ShoppingCart,
  Smartphone,
  BrainCircuit,
  LayoutDashboard,
  Users,
  ArrowRight,
} from "lucide-react";

const solutions = [

  {
    icon: <ShoppingCart size={34} />,
    title: "Ecommerce Development",

    description:
      "Scalable ecommerce platforms with payment integrations, inventory systems, responsive storefronts and modern customer experiences.",

    link: "/ecommerce-development",
  },

  {
    icon: <Smartphone size={34} />,
    title: "Mobile App Development",

    description:
      "Modern Android and iOS applications with realtime systems, cloud synchronization and enterprise-grade architecture.",

    link: "/mobile-app-development",
  },

  {
    icon: <Users size={34} />,
    title: "CRM Software",

    description:
      "Custom CRM platforms for lead management, analytics, workflow automation and enterprise business operations.",

    link: "/crm-software-development",
  },

  {
    icon: <BrainCircuit size={34} />,
    title: "AI Solutions",

    description:
      "AI-powered software systems including OCR, automation workflows, analytics dashboards and intelligent business platforms.",

    link: "/ai-software-solutions",
  },

  {
    icon: <LayoutDashboard size={34} />,
    title: "Dashboard Development",

    description:
      "Enterprise dashboards, reporting systems, realtime analytics and cloud-based business monitoring solutions.",

    link: "/custom-dashboard-development",
  },

];

const SolutionsOverview = () => {

  return (

    <section className="solutions-section">

      <div className="solutions-container">

        {/* HEADER */}
        <div className="solutions-header">

          <p className="solutions-label">
            SOFTWARE SOLUTIONS
          </p>

          <h2 className="solutions-title">

            Software Solutions
            <br />

            We Build

          </h2>

          <p className="solutions-description">

            We develop scalable enterprise software,
            AI systems, ecommerce platforms, mobile
            applications and cloud-ready business
            automation solutions.

          </p>

        </div>

        {/* GRID */}
        <div className="solutions-grid">

          {solutions.map((solution, index) => (

            <div
              className="solution-card"
              key={index}
            >

              <div className="solution-icon">

                {solution.icon}

              </div>

              <h3>
                {solution.title}
              </h3>

              <p>
                {solution.description}
              </p>

              <NavLink
                to={solution.link}
                className="solution-link"
              >

                Explore Solution

                <ArrowRight size={18} />

              </NavLink>

            </div>

          ))}

        </div>

      </div>

    </section>

  );

};

export default SolutionsOverview;